export default "__VITE_ASSET__JfgAMEAe__"